import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "option-group";
var attributes = {
    LABEL: 'label'
};
export var OPTION_GROUP_CONSTANTS = {
    elementName: elementName,
    attributes: attributes
};
